import gql from "graphql-tag";
import AnswerablePostFields from "lib/graphql/fragments/engagement/AnswerablePostFields";

export default gql`
  mutation UnsetPostReplyAnswer($objectId: ID!) {
    unsetPostReplyAnswer(objectId: $objectId) {
      ...AnswerablePostFields
    }
  }

  ${AnswerablePostFields}
`;
